/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import logo from './logo.png';

const getStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '59px',
    alignItems: 'center',
    padding: '27px 43px 0 43px',
  },
  logo: {
    height: '17px',
  },
  childrenWrapper: {
    display: 'flex',
    flexDirection: 'row-reverse',
    flex: 1,
  },
});

export interface ISDKHeaderProps {
  className?: string;
  children?: React.ReactNode;
}

export const SDKHeader: React.FC<ISDKHeaderProps> = React.memo(({ children, className }) => {
  const i18n = useContext(I18nContext);
  const styles = useDefaultStyles(getStyles);
  return (
    <div className={classNames(styles.root, className, 'container-fluid')}>
      <img className={styles.logo} src={logo} alt={i18n.getString(_TL_('Microsoft Advertising'))} />
      <div className={styles.childrenWrapper}>
        {children}
      </div>
    </div>
  );
});
